/**
 * Utility functions for detecting the application context (HubSpot)
 */

/**
 * Checks if the application is running in HubSpot context
 * by checking if the current URL contains 'hubspot'
 *
 * @returns {boolean} True if running in HubSpot context, false otherwise
 */
export const isHubSpotContext = (): boolean => {
  if (typeof window === 'undefined') {
    return false
  }

  if (!window.location) {
    return false
  }

  return window.location.href.toLowerCase().includes('hubspot')
}
